<template>
    <div class="">

        <!-- header-->
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900 mb-2"><slot name="header"></slot></h1>
            </div>
        </div>
        <div class="flex justify-end">
            <slot name="button"></slot>
        </div>
        <div class="flex flex-col w-full">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <div v-show="has_filter" class="bg-white p-4 flex items-center justify-between">
                            <div class="flex justify-start">
                                <slot name="search"></slot>
                            </div>
                            <div class="flex justify-end">
                                <slot name="filter"></slot> 
                            </div>    
                        </div>
                        <table class="min-w-full divide-y divide-gray-300">
                            <thead class="bg-gray-100">
                            <tr v-if="header.length > 0">
                                <th v-for="item in header"
                                    scope="col" class="pl-6 py-3.5 pr-6 text-left text-sm font-semibold text-gray-900">
                                    <div class="items-center">{{ item }}</div>
                                </th>
                            </tr>
                            <tr v-if="header_with_options.length > 0">
                                <th v-for="item in header_with_options" @click="$emit('sort', item.key)"
                                    scope="col" class="pl-6 py-3.5 pr-6 text-left text-sm font-semibold text-gray-900">
                                    <div class="items-center">
                                        {{ item.name }}
                                        <a v-show="item.sorted === 'asc' || item.sorted === null" class="fa fa-angle-down">
                                        </a>
                                        <a v-show="item.sorted === 'desc'" class="fa fa-angle-up">
                                        </a>
                                    </div> 
                                </th>
                            </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                            <slot></slot>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "TailwindTable",

    props:{
            header: {type:Array, default: () => ([])},
            has_filter: {default: false},
            header_with_options: {type:Array, default: () => ([])},
        },


}
</script>

<style scoped>

</style>
